import { CapoPlugin } from "/home/runner/work/pennywhales-tma/pennywhales-tma/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];